module.exports = __webpack_public_path__ + "static/img/page1-image0.15a45d9b.png";